module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./~/axios/index.js
// module id = 73
// module chunks = 35783957827783 96961042003272 142807904292071